import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import Input from "../../Components/input/input";
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { Problem, initialProblem } from "./Problem";
import TaskGridLookup from "../../Components/Lookup/Lookup";
import { ChangeData } from "../../utils/Change/changeTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import { ProblemData } from "../../utils/Problem/problemTypes";
import TextArea from "../../Components/TextArea/TextArea";
import ses from "../../Assets/ses.jpg";

import { authFetch } from "../../utils/Security/authFetch";
import { joinMulti } from "../../utils/multiValue";
import FileUploader from "../../Components/FileUpload/FileUpload";
import Button from "../../Components/button/button";
import { getSignatureLines } from "../../utils/emailSignature";

const ProblemAdd: React.FC = () => {
  const organization = localStorage.getItem("organization") || undefined;
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const storedUsername = localStorage.getItem("username");

  const [problem, setProblem] = useState<Problem>(initialProblem);
  const navigate = useNavigate();
  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
  const [selectedTask, setSelectedTask] = useState<
    (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  >([]);
  const [customer, setCustomer] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [network, setNetwork] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [emails, setEmails] = useState<[]>();
  useEffect(() => {
    const { urgency, impact } = problem;
    if (!urgency || !impact) return;

    const key = `${urgency}-${impact}`;
    let priority = "";
    //console.log("${urgency}-${impact}", urgency, impact);
    if (key === "Critical-Critical") priority = "Critical";
    else if (
      key === "Critical-High" ||
      key === "High-High" ||
      key === "High-Critical"
    )
      priority = "High";
    else if (
      key === "Critical-Medium" ||
      key === "High-Medium" ||
      key === "Medium-High" ||
      key === "Medium-Medium" ||
      key === "Medium-Critical"
    )
      priority = "Medium";
    else if (
      key === "Low-Low" ||
      key === "Low-High" ||
      key === "Low-Medium" ||
      key === "Low-Critical" ||
      key === "Medium-Low" ||
      key === "High-Low" ||
      key === "Critical-Low"
    )
      priority = "Low";
    else if (
      key === "Medium-Low" ||
      key === "High-Low" ||
      key === "Critical-Low"
    )
      priority = "Low";
    setProblem((prev) => ({
      ...prev,
      priority,
    }));
  }, [problem.urgency, problem.impact]);
  useFetchFullName((fullName: string) => {
    setProblem((prev) => ({ ...prev, user: fullName }));
  });
  const handleTaskSelect = (
    tasks: (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId);
    handleChange("relatedobject", ticketIds);
    setSelectedTask(tasks);
  };
  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedPosition = localStorage.getItem("position") ?? "";
    if (storedUsername) {
      setProblem((prev) => ({
        ...prev,
        createdby: storedUsername,
        responsiblePerson: storedUsername,
        responsibleTeam: storedPosition,
      }));
    }
  }, []);
  const handleChange = (field: keyof Problem, value: any) => {
    setProblem((prev) => {
      const updated = { ...prev, [field]: value };

      updated.affectedSite =
        isallsite === "true" ? ["All Sites"] : updated.affectedSite;
      updated.affectedLink =
        isalllink === "true" ? ["All Links"] : updated.affectedLink;
      updated.affectedNetwork =
        isallnetwork === "true" ? ["All Networks"] : updated.affectedNetwork;

      return updated;
    });
  };

  const validateForm = (): boolean => {
    if (!problem) {
      alert("problem data is not available.");
      return false;
    }

    const requiredFields: (keyof Problem)[] = [
      "problemStartDatetime",
      "impact",
      "urgency",
      "summary",
      "description",
    ];

    for (const field of requiredFields) {
      const value = problem[field];
      if (
        value === undefined ||
        value === null ||
        value.toString().trim() === ""
      ) {
        alert(`Please fill the required field`);
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    //console.log("Submitting problem:", problem); // Log the state before submission

    try {
      const response = await authFetch(`${config.apiBaseUrl}/api/problems`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(problem),
      });
      const savedIncident = await response.json();
      problem.ticketId = savedIncident.ticketId;
      problem.ticketCreationDatetime = savedIncident.ticketCreationDatetime;

      try {
        const emails = ["c.hanna@bcomsat.com", "g.kattan@bcomsat.com"];

        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            to: emails,
            subject: `A Problem with ID: ${problem.ticketId} Has been Opened`,
            body: `
             A ticket with ID: ${
               problem.ticketId
             } has been opened with the following comment <br><br>
              Ticket ID:${problem.ticketId}<br><br>
Status: New <br><br>
Problem creation date/time:    ${problem.problemStartDatetime?.replace(
              "T",
              " "
            )}<br>
Problem closure date/time ${
              problem.problemCloseDatetime
                ? problem.problemCloseDatetime.replace("T", " ")
                : ""
            }<br><br>

Customer: ${problem.affectedCustomer} <br><br>
Network:  ${problem.affectedNetwork}<br><br>
Site: ${problem.affectedSite} <br><br>
Link: ${problem.affectedLink} <br><br>
Summary: ${problem.summary} <br><br>
Description: ${problem.description} <br><br>
Error Type: ${problem.errorType} <br><br>
Closure Code: ${problem.closureCode} <br><br>
Solution  : ${problem.solution} <br><br>
  <br><br>
              Regards, <br><br>

                 <a href="https://bdm.bcomsat.com" target="_blank" style="color: #ffa500; font-weight: bold; text-decoration: none;">
        👉 View Problem Details
      </a>
    </p>
 <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">
          <img src="cid:seslogo" alt="SES Logo" width="80" style="display: block;">
        </td>

        <td>
          <div style="padding: 12px; border-left: 4px solid #ffa500; background-color: #f9f9f9; color: #555; font-size: 13px;">
            <strong>Managed Services Operations</strong><br>
             ${getSignatureLines(problem.affectedCustomer, "#555")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
          }),
        });
        localStorage.setItem("email", problem.email);
        //console.log("Email sent successfully!");
      } catch (emailErr) {
        console.error("Failed to send email notification:", emailErr);
      }

      if (!response.ok) throw new Error("Failed to submit problem");

      alert("problem submitted successfully!");
      setProblem({ ...initialProblem, ticketId: problem.ticketId });
      navigate("/problem");
    } catch (error) {
      alert(`Submission error: ${(error as Error).message}`);
      console.error(`Submission error: ${(error as Error).message}`);
    }
  };

  useEffect(() => {
    if (!problem.ticketId) {
      const randomId = `PRB${Math.floor(10000 + Math.random() * 90000)}`;
      setProblem((prev) => ({
        ...prev,
        ticketId: randomId,
      }));
    }
  }, []);

  return (
    <div className="incident-form">
      <section className="form-section">
        <h3>Problem Infoproblemtion</h3>
        <div className="grid">
          <Input
            type="text"
            label="Created By"
            value={problem.createdby ?? ""}
            onChange={(val) => handleChange("createdby", val)}
            readOnly
          />
          <Input
            readOnly
            type="text"
            label="Ticket ID"
            value={problem.ticketId || ""}
            onChange={() => {}}
          />
          {/* <Input type="datetime-local" label="Ticket creation" value={problem.ticketCreation} onChange={(val) => handleChange('ticketCreation', val)} /> */}
          {/* <Input type="datetime-local" label="Ticket closure" value={problem.ticketClosure} onChange={(val) => handleChange('ticketClosure', val)} /> */}

          <Input
            type="datetime-local"
            label="Problem Start Date/Time"
            required={true}
            value={problem.problemStartDatetime}
            onChange={(val) => handleChange("problemStartDatetime", val)}
          />
          <Input
            type="datetime-local"
            label="Problem End Date/Time"
            value={problem.problemCloseDatetime}
            onChange={(val) => handleChange("problemCloseDatetime", val)}
          />
        </div>
      </section>

      <section className="form-section">
        <h3>Customer & Network</h3>
        <div className="grid">
          {!isAdmin && (
            <ApiDropdown
              api="affected-customers"
              required={true}
              labelKey="customername"
              disabled
              value={organization}
              valueKey="customername"
              label="Customer"
              isMulti
              onOpen={async () => {
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();

                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  //console.log("Fetched emails:", emails);

                  handleChange("foruserid", userIds);

                  handleChange("affectedCustomer", [organization]);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
          {isAdmin && (
            <ApiDropdown
              api="affected-customers"
              labelKey="customername"
              required={true}
              valueKey="customername"
              label="Customer"
              isMulti
              onChange={async (val) => {
                setCustomer(val);
                //console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", val);
                handleChange("affectedCustomer", val);
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();
                  //console.log("Fetched user IDs:", userIds);

                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  //console.log("Fetched emails:", emails);

                  handleChange("foruserid", userIds);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
          {!isAdmin && organization && (
            <ApiDropdown
              api={`everything/networks?customer=${organization}`}
              labelKey="label"
              valueKey="value"
              label=" Networks"
              required={true}
              isMulti
              onChange={(val) => {
                setNetwork(val);
                handleChange("affectedNetwork", val);
              }}
            />
          )}

          {!isAdmin && organization && (
            <>
              {network && (
                <ApiDropdown
                  api={`everything/sites?customer=${organization}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label=" Site"
                  isMulti
                  onChange={(val) => {
                    setSite(val);
                    handleChange("affectedSite", val);
                  }}
                />
              )}

              {site && (
                <ApiDropdown
                  api={`everything/links?customer=${organization}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label=" Link"
                  isMulti
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )}

              <ApiDropdown
                api={`everything/asset?customer=${organization}&network=${network}`}
                labelKey="label"
                valueKey="value"
                label="Assets"
                isMulti
                onChange={(val) => handleChange("asset", joinMulti(val))}
              />
            </>
          )}

          {isAdmin && (
            <>
              {customer && (
                <ApiDropdown
                  api={`everything/networks?customer=${customer}`}
                  labelKey="label"
                  valueKey="value"
                  label="Networks"
                  isMulti
                  required
                  onChange={(val) => {
                    setNetwork(val);
                    handleChange("affectedNetwork", val);
                  }}
                />
              )}

              {network && (
                <ApiDropdown
                  api={`everything/sites?customer=${customer}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Site"
                  isMulti
                  onChange={(val) => {
                    setSite(val);
                    handleChange("affectedSite", val);
                  }}
                />
              )}

              {site && (
                <ApiDropdown
                  api={`everything/links?customer=${customer}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label="Link"
                  isMulti
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )}

              <ApiDropdown
                api={`everything/asset?customer=${customer}&network=${network}`}
                labelKey="label"
                valueKey="value"
                label="Assets"
                isMulti
                onChange={(val) => handleChange("asset", joinMulti(val))}
              />
            </>
          )}
        </div>
      </section>
      <section className="form-section">
        <h3>Problem Severity</h3>
        <div className="grid">
          <ApiDropdown
            api="Urgencys"
            required
            labelKey="name"
            valueKey="name"
            label="Urgency"
            onChange={(val) => handleChange("urgency", val)}
          />
          <ApiDropdown
            api="Impacts"
            required
            labelKey="name"
            valueKey="name"
            label="Impact"
            onChange={(val) => handleChange("impact", val)}
          />

          <Input
            readOnly
            type="text"
            label="Priority"
            value={problem.priority || ""}
            onChange={() => {}}
          />
        </div>
      </section>

      <section className="form-section">
        <h3>Problem Details</h3>
        <div className="grid2">
          <TextArea
            label="Summary"
            required={true}
            value={problem.summary}
            style={{
              minHeight: "30px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            onChange={(val) => handleChange("summary", val)}
          />
          <TextArea
            label="Description"
            required={true}
            value={problem.description}
            style={{
              minHeight: "100px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            onChange={(val) => handleChange("description", val)}
          />
        </div>
      </section>
      <section className="form-section">
        <h3>Responsibilty</h3>
        <div className="grid">
          <>
            {isAdmin && (
              <Input
                type="text"
                label="Responsible Team"
                value={problem.responsibleTeam}
                onChange={(val) => handleChange("responsibleTeam", val)}
                readOnly
              />
            )}
            {isAdmin && (
              <Input
                type="text"
                label="Responsible Person"
                value={problem.responsiblePerson}
                onChange={(val) => handleChange("responsiblePerson", val)}
                readOnly
              />
            )}
          </>
        </div>
      </section>
      <section className="form-section">
        <h3>Related Object</h3>
        <div className="grid">
          <FileUploader
            value={problem.filePath}
            onRemove={(path) =>
              handleChange("filePath", (problem.filePath || []).filter((p: any) => p !== path))
            }
            onChange={async (files, paths) => {
              if (!files || !paths.length) return;

              const uploadedPaths: string[] = [];

              for (let i = 0; i < files.length; i++) {
                const safeFileName = files[i].name.replace(/\s+/g, "_");

                // Create a new File object with the updated name
                const renamedFile = new File([files[i]], safeFileName, {
                  type: files[i].type,
                });

                const formData = new FormData();
                formData.append("file", renamedFile);

                try {
                  const response = await authFetch(
                    `${config.apiBaseUrl}/api/problems/upload`,
                    {
                      method: "POST",
                      body: formData,
                    }
                  );

                  if (response.ok) {
                    let { path } = await response.json();

                    // Ensure spaces are replaced with "_" before saving in DB
                    path = path.replace(/\s+/g, "_");

                    uploadedPaths.push(path);
                    console.log(
                      "jacksonnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn",
                      uploadedPaths
                    );
                  } else {
                    console.error(`Upload failed for file: ${safeFileName}`);
                  }
                } catch (error) {
                  console.error("Error uploading file", error);
                }
              }

              if (uploadedPaths.length) {
                handleChange("filePath", [
                  ...(problem.filePath || []),
                  ...uploadedPaths,
                ]);
              }
            }}
          />

          {isAdmin && (
            <>
              <button onClick={handleOpenTaskLookup}>
                Select Related Ticket
              </button>
              {selectedTask && selectedTask.length > 0 && (
                <div>
                  <p>
                    <strong>Selected Tasks:</strong>
                  </p>
                  <ul>
                    {selectedTask.map((task, index) => (
                      <li key={index}>{task.ticketId}</li>
                    ))}
                  </ul>
                </div>
              )}
              <TaskGridLookup
                isOpen={isTaskLookupOpen}
                onClose={handleCloseTaskLookup}
                onSelect={handleTaskSelect}
                selectedItems={selectedTask}
              />{" "}
            </>
          )}
        </div>
      </section>

      <div className="submit-section">
        <Button onClick={handleSubmit}>Submit problem</Button>
      </div>
    </div>
  );
};

export default ProblemAdd;
